import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { db } from "@/db/connection";

const lookupProfileByUsername = createServerFn()
  .inputValidator((input: string) => input)
  .handler(async ({ data: username }) => {
    const user = await db.query.users.findFirst({
      where: { username: username.toLowerCase() },
      with: {
        selfProfile: {
          columns: { playerProfileId: true },
        },
      },
    });

    return user?.selfProfile?.playerProfileId ?? null;
  });

export const Route = createFileRoute("/p/$username")({
  loader: async ({ params: { username } }) => {
    // If the param is a numeric profile ID, redirect directly
    const numericId = Number(username);

    if (!Number.isNaN(numericId)) {
      throw redirect({
        to: "/profile/$profileId",
        params: { profileId: String(numericId) },
      });
    }

    const profileId = await lookupProfileByUsername({ data: username });

    if (!profileId) {
      throw notFound();
    }

    throw redirect({
      to: "/profile/$profileId",
      params: { profileId: profileId.toString() },
    });
  },
});
